export class ExchangePair {
  idExchangePair: number;
  idExchange: number;
  idCurrencyPrimary: number;
  idCurrencySecondary: number;
  offset: number;
  locked: boolean;

  constructor(
    idExchangePair: number,
    idExchange: number,
    idCurrencyPrimary: number,
    idCurrencySecondary: number,
    offset: number,
    locked: boolean,
  ) {
    this.idExchangePair = idExchangePair;
    this.idExchange = idExchange;
    this.idCurrencyPrimary = idCurrencyPrimary;
    this.idCurrencySecondary = idCurrencySecondary;
    this.offset = offset;
    this.locked = locked;
  }

  static fromRaw(raw: any): ExchangePair {
    return new ExchangePair(
      raw.idExchangePair,
      raw.idExchange,
      raw.idCurrencyPrimary,
      raw.idCurrencySecondary,
      raw.offset,
      Boolean(raw.locked),
    );
  }

  clone(): ExchangePair {
    return new ExchangePair(
      this.idExchangePair,
      this.idExchange,
      this.idCurrencyPrimary,
      this.idCurrencySecondary,
      this.offset,
      this.locked,
    );
  }

  toPayload(): any {
    return {
      idExchangePair: this.idExchangePair,
      idExchange: this.idExchange,
      idCurrencyPrimary: this.idCurrencyPrimary,
      idCurrencySecondary: this.idCurrencySecondary,
      offset: this.offset,
      locked: this.locked,
    };
  }
}
